import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cacheLoaded: false,
    image: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    cache: {
      about: {
        competition: '',
        location: '',
        date: '',
      },
      live: {
        info: '',
        disabled: true,
        lockedTabs: [],
      },
      settings: {
        categories: [],
        spacing: [],
        distances: [],
        sessions: [],
        finals: [],
      },
      players: [],
      teams: [],
      mixts: [],
      finals: [],
      qualifications: [],
    },
    about: {
      competition: '',
      date: '',
      location: '',
    },
  },
  mutations: {
    setCache(state, cache) {
      // eslint-disable-next-line
      state.cache = cache
      state.about = cache.about
      state.cacheLoaded = true

      // state.cache.live.disabled = false
      // state.cache.live.lockedTabs = []
    },
    setImage(state, image) {
      state.image = image
    },
  },
})
